import { CubeScanIcon } from './CubeScanIcon';

/**
 * author: Google
 * id 101B8439-F611-400E-A2DF-0D7AE40C1005
 * name cube-scan
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cube-scan.svg
 * tags
 */
export const ViewInArIcon = CubeScanIcon;
export default ViewInArIcon